
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCookies } from "../../../helper/utils";
import api from "../../../helper/api";

export const getClientList = createAsyncThunk("user/getClientList", async () => {
  const response = await api.get("admin/list");
  console.log(13, response)
  return response;
});


const getClientListSlice = createSlice({
  name: "user",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: {
      ignoredPaths: ["payload.headers"],
    },
  }),
  extraReducers: (builder) => {
    builder
      .addCase(getClientList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getClientList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getClientList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default getClientListSlice.reducer;
